"use strict";

var PropTypes = require("prop-types");

var VisibilityStore = require("../client/VisibilityStore");

var ActionsHelper = require("../actions/ActionsHelper");
var HtmlHelper = require("../shared/HtmlHelper");
var InputHelper = require("../shared/InputHelper");
var ProjectConstants = require("./ProjectConstants");
var Dispatcher = require("../dispatcher/Dispatcher");

var GiftArrayValidator = require("./validations/GiftArrayValidator");

var classNames = require("classnames");

class GiftArray extends React.Component {
	constructor(props) {
		super(props);

		// Ideally we would get the tangible (project/pledge) from the store, but that does not exist on the server
		// We optimistically render on the server with the props[this.props.tangibleType] (props.project/props.pledge) (the @Model) and on the
		//  client, we will get the tangible from the store
		var tangible = props.tangibleStore.get(props.tangibleType) || props[props.tangibleType] || {};
		tangible = JSON.parse(JSON.stringify(tangible)); // clone the tangible (project/pledge) to avoid reference

		var overrides = props.overrides || {};

		var giftAmounts = [];
		if (overrides.giftAmounts) {
			giftAmounts = overrides.giftAmounts.slice(0); // clone the array to avoid reference
		} else if (props.giftAmounts) {
			giftAmounts = props.giftAmounts.slice(0); // clone the array to avoid reference
		}

		var tangibleCode;

		if (props.isDesignMode) {
			if (!tangible) {
				tangible = {
					[props.displayCodeProperty]: "DESIGN01",
					description: "test description"
				};
			}
		}

		if (overrides.includeOther || props.includeOther) {
			giftAmounts = giftAmounts.concat("other");
		}

		//If subaccounts is not visible or if we are in a category or searchResults component, we always want to select the first value.
		var selectedAmount = "";
		if (props.context || !this.isSubaccountVisible()) {
			var initialSelectedIndex = props.defaultSelectedAmountIndex ? (Number(props.defaultSelectedAmountIndex) || 1) - 1 : 0;
			//If the index is invalid, just select the first item.
			if (initialSelectedIndex >= giftAmounts.length || initialSelectedIndex < 0) {
				initialSelectedIndex = 0;
			}
			selectedAmount = giftAmounts[initialSelectedIndex];
		}

		var otherSelected = false;
		if (selectedAmount === "other") {
			otherSelected = true;
			selectedAmount = 0;
		}

		if (props.context) {
			if (props[props.tangibleType]) {
				tangibleCode = props[props.tangibleType].tangibleCode;
			} else if (props.isDesignMode) {
				tangibleCode = tangible[props.displayCodeProperty];
			}
		}

		this.state = {
			selectedAmount,
			otherSelected,
			showOtherTextbox: false,
			tangible,
			tangibleCode,
			giftAmounts,
			instanceId: HtmlHelper.getId($("body"))
		};

		this._onChange = this._onChange.bind(this);

		this.instanceId = HtmlHelper.getId($("body"));
	}

	handleAmountSelected(event) {
		var selectedValue = event.currentTarget.value;

		var otherSelected = false;
		if (selectedValue === "other") {
			otherSelected = true;
			selectedValue = 0;
		}
		if (this._isMounted) {
			this.setState({
				otherSelected,
				showOtherTextbox: otherSelected
			}, () => {
				if (otherSelected && this.refs.otherTextbox) {
					$(this.refs.otherTextbox).val('');
					this.refs.otherTextbox.focus();
				}
			});
		}
		this.props.tangibleActions.setGiftAmount(selectedValue, this.state.tangibleCode, this.state.context);
	}

	handleBlurOther() {
		this.setState({
			focusedOther: false,
			showOtherTextbox: false
		});
	}

	handleFocusOther() {
		this.setState({ focusedOther: true });
	}

	handleOtherAmountChange(event) {
		// Enforce that the value can be a number followed by a decimal and up to two digits
		// valid: 8, 8., ., .8, .88
		// invalid: .888, 8.888, asdf, '8,888'
		if (InputHelper.isAmountValid(event.currentTarget.value)) {
			this.props.tangibleActions.setGiftAmount(ActionsHelper.convertFormattedAmountToNumberString(event.currentTarget.value), this.state.tangibleCode, this.state.context);
		}
	}

	isSubaccountVisible() {
		if (VisibilityStore.hasRule("subaccountGiftArray") && $("[data-react-component-name='SubaccountGiftArray']").length) {
			return true;
		}

		// Subaccounts is either not visible or is has not been loaded yet.
		// If it has not been loaded yet just set the default and SubaccountGiftArray will remove it if necessary.
			return false;
	}

	// If keepDecimals, do not format out the decimals.
	// User entered information should not strip out decimals.
	formatAmount(amount, keepDecimals) {
		var formattedAmount = amount;
		if (amount === "other") {
			formattedAmount = "Other";
		} else {
			formattedAmount = ActionsHelper.formatAmount(amount, this.props.showDecimals, this.props.includeCurrencySymbol, keepDecimals);
		}
		return formattedAmount;
	}

	_onChange() {
		this.setState(this.props.tangibleStore.getState());
	}

	componentDidMount() {
		this._isMounted = true;

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}
		var context = this.props.context;
		var contextId = "";
		if (context) {
			switch (context) {
				case "tangible":
					context = "category";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=category]").attr("id");
					break;
				case "result":
					context = "search";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]").attr("id");
					break;
			}
			context += `_${contextId}`;
		}
		//Set custom validator
		this.setCustomValidation();

		this.props.tangibleActions.setMinimumAmount(
			this.props.minimumAmount,
			this.state.tangibleCode,
			context
		);

		var { selectedAmount, otherSelected } = this.state;
		if (!context) {
			// Check sessionStorage for cachedValues, update to use "other" value if indicated
			var cachedValues = {};
			if (this.props.tangibleActions.getCachedValues) {
				cachedValues = this.props.tangibleActions.getCachedValues() || {};
			}

			if (cachedValues.amount || cachedValues.isOtherSelected !== undefined) {
				// At this point, selectedAmount has been set by the component
				otherSelected = cachedValues.isOtherSelected && this.state.giftAmounts.includes("other");

				if (otherSelected) {
					//0 can be selected for other.  We want to keep 0, if other is selected and not default to this.state.selectedAmount
					selectedAmount = cachedValues.amount || 0;
				} else if (cachedValues.amount) {
					var cachedGiftAmount = this.state.giftAmounts
						.find(giftAmount =>
							// Check both an exact match and a numeric match (50 == "50" or "50.00" == "50")
							giftAmount === cachedValues.amount ||
							Number(giftAmount) === Number(cachedValues.amount)
						);

					if (cachedGiftAmount !== undefined) {
						selectedAmount = cachedGiftAmount;
					}
				}
			}
		}

		// At this point, selectedAmount has been set by the component
		this.props.tangibleActions.setGiftAmount(
			selectedAmount,
			this.state.tangibleCode,
			context
		);

		this.setState({
			context,
			otherSelected,
			selectedAmount
		});

		this.props.tangibleStore.addChangeListener(this._onChange);

		Dispatcher.dispatch({
			actionType: ProjectConstants.GIFT_ARRAY_LOADED,
		});
	}

	componentWillUnmount() {
		this.props.tangibleStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
			this.props.tangibleActions.setGiftAmount(null, this.state.tangibleCode, this.state.context);
		}

		this._isMounted = false;
	}

	setCustomValidation() {
		if (!this.props.isDesignMode) {
			var $currentNode = $(ReactDOM.findDOMNode(this));

			if (this.props.hideWhenSubaccounts) {
				$currentNode = $currentNode.add($currentNode.closest("[data-component='buttonGiftAmount'],[data-component='radioGiftAmount'],[data-component='selectGiftAmount']"));
			}

			$currentNode.each((index, element) => {
				var $element = $(element);
				$element.attr("data-has-custom-validator", true).data({ customValidator: this.validateDonationMeetsMinimum.bind(this, $element) });
			});
		}
	}

	validateDonationMeetsMinimum($element) {
		// Returns {isValid: bool, and errorMessages: string[]}
		return GiftArrayValidator.validateDonationMeetsMinimum(this.props.tangibleStore, this.state.context, this.state.tangibleCode);
	}

	renderButton(selectedAmount) {
		var context = this.state.context;
		var name = `${context ? `giftAmount_${context}_${this.state.tangibleCode}` : "giftAmount"}"_"${this.state.instanceId}`;
		var containsOther = this.state.giftAmounts.includes("other");

		return (
			<div className="gift-amounts" data-hide={this.props.hideWhenSubaccounts ? "subaccounts" : null}>
				{this.state.giftAmounts.map((amount, index) => {
					var formattedAmount = this.formatAmount(amount);

					if (amount === "other") {
						var otherChecked = !!this.state.otherSelected;
						var otherSelectedAmount = ActionsHelper.replaceAmountDecimalSymbols(selectedAmount);
						if (this.state.otherSelected && !this.state.showOtherTextbox && selectedAmount) {
							formattedAmount = this.formatAmount(selectedAmount, true);
						} else {
							formattedAmount = this.props.otherText;
						}

						return (
							<label
								className={classNames(["giftAmount", "giftAmountOther", "radio-button", this.props.childClass, { selected: otherChecked }])}
								data-override-classes={this.props.childClass}
								key={amount}
								data-component={`${this.props.beginningComponentName}ButtonGiftArray.button`}
							>
								{this.state.showOtherTextbox && this.state.otherSelected &&
									<input id="txtDonationAmount" name="txtDonationAmount" type="text" inputMode="decimal" value={otherSelectedAmount} maxLength="10" onBlur={this.handleBlurOther.bind(this)} onChange={this.handleOtherAmountChange.bind(this)} ref="otherTextbox" />
								}
								{!this.state.showOtherTextbox &&
									<span>
										<input type="radio" name={name} value={amount} onClick={this.handleAmountSelected.bind(this)} checked={otherChecked} />
										<span>{formattedAmount}</span>
									</span>
								}
							</label>
						);
					}

					var amountChecked = (selectedAmount === amount && !this.state.otherSelected);

					return (
						<label
							className={classNames(["giftAmount", "radio-button", this.props.childClass, { selected: amountChecked, lastAmount: index === this.state.giftAmounts.length - (containsOther ? 2 : 1) }])}
							data-override-classes={this.props.childClass}
							key={amount}
							data-component={`${this.props.beginningComponentName}ButtonGiftArray.button`}
						>
							<input type="radio" name={name} value={amount} onChange={this.handleAmountSelected.bind(this)} checked={amountChecked} />
							<span>{formattedAmount}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderRadio(selectedAmount) {
		var context = this.state.context;
		var name = `${context ? `giftAmount_${context}_${this.state.tangibleCode}` : "giftAmount"}_${this.state.instanceId}`;
		var containsOther = this.state.giftAmounts.includes("other");

		return (
			<div className="gift-amounts" data-hide={this.props.hideWhenSubaccounts ? "subaccounts" : null}>
				{this.state.giftAmounts.map((amount, index) => {
					var formattedAmount = this.formatAmount(amount);
					var amountChecked = (selectedAmount === amount && !this.state.otherSelected);

					if (amount === "other") {
						var otherChecked = !!this.state.otherSelected;
						var otherSelectedAmount;
						if (!this.state.focusedOther) {
							otherSelectedAmount = this.formatAmount(selectedAmount);
						} else {
							otherSelectedAmount = ActionsHelper.replaceAmountDecimalSymbols(selectedAmount);
							otherSelectedAmount = otherSelectedAmount === "0" ? "" : otherSelectedAmount;
						}

						return (
							<label
								className={classNames(["giftAmount", "giftAmountOther", this.props.childClass, { selected: otherChecked }])}
								data-override-classes={this.props.childClass}
								key={amount}
								data-component={`${this.props.beginningComponentName}RadioGiftArray.radio`}
							>
								<span>
									<input type="radio" name={name} value={amount} onChange={this.handleAmountSelected.bind(this)} checked={otherChecked} />
									<span data-component={`${this.props.beginningComponentName}RadioGiftArray.radio.label`}>{this.props.otherText}</span>
								</span>
								{this.state.otherSelected &&
									<input id="txtDonationAmount" name="txtDonationAmount" type="text" inputMode="decimal" value={otherSelectedAmount} maxLength="10" onBlur={this.handleBlurOther.bind(this)} onChange={this.handleOtherAmountChange.bind(this)} onFocus={this.handleFocusOther.bind(this)} ref="otherTextbox" />
								}
							</label>
						);
					}

					return (
						<label
							className={classNames(["giftAmount", this.props.childClass, { selected: amountChecked, lastAmount: index === this.state.giftAmounts.length - (containsOther ? 2 : 1) }])}
							data-override-classes={this.props.childClass}
							key={amount}
							data-component={`${this.props.beginningComponentName}RadioGiftArray.radio`}
						>
							<input type="radio" name={name} value={amount} onChange={this.handleAmountSelected.bind(this)} checked={amountChecked} />
							<span data-component={`${this.props.beginningComponentName}RadioGiftArray.radio.label`}>{formattedAmount}</span>
						</label>
					);
				})}
			</div>
		);
	}

	renderDropdown(selectedAmount) {
		var otherSelectedAmount;
		if (!this.state.focusedOther) {
			otherSelectedAmount = this.formatAmount(selectedAmount);
		} else {
			otherSelectedAmount = ActionsHelper.replaceAmountDecimalSymbols(selectedAmount);
			otherSelectedAmount = otherSelectedAmount === "0" ? "" : otherSelectedAmount;
		}

		return (
			<div className="gift-amounts" data-hide={this.props.hideWhenSubaccounts ? "subaccounts" : null}>
				<select
					className={classNames(["gift-amounts", this.props.childClass])}
					style={this.props.isDesignMode ? { "pointerEvents": "none" } : undefined}
					data-override-classes={this.props.childClass}
					selected={this.state.otherSelected ? "other" : selectedAmount}
					onChange={this.handleAmountSelected.bind(this)}
					data-component={`${this.props.beginningComponentName}SelectGiftArray.select`}
					value={this.state.otherSelected ? "other" : (selectedAmount || "")}
				>
					// adds a non-selected option when the subaccounts array is visible
					{this.isSubaccountVisible() &&
						<option key="" value="" className={classNames(["giftAmount", {}])}> </option>
					}
					{this.state.giftAmounts.map((amount, index) => {
						var formattedAmount = this.formatAmount(amount);
						var amountChecked = (selectedAmount === amount && !this.state.otherSelected);
						if (amount === "other") {
							amountChecked = !!this.state.otherSelected;
							formattedAmount = this.props.otherText;
						}

						return (
							<option
								className={classNames(["giftAmount", { selected: amountChecked, giftAmountOther: amount === "other" }])}
								key={amount}
								value={amount}
							>
								{formattedAmount}
							</option>
						);
					})}
				</select>
				{this.state.otherSelected &&
					<label className={"giftAmount giftAmountOther selected"} key={"other"}>
						<input id="txtDonationAmount" name="txtDonationAmount" type="text" inputMode="decimal" value={otherSelectedAmount} maxLength="10" onBlur={this.handleBlurOther.bind(this)} onChange={this.handleOtherAmountChange.bind(this)} onFocus={this.handleFocusOther.bind(this)} ref="otherTextbox" />
					</label>
				}
			</div>
		);
	}

	renderContainer() {
		var selectedAmount;
		if (this.state.context) {
			selectedAmount = this.props.tangibleStore.getSelectedAmount(this.state.context, this.state.tangibleCode);
		} else {
			selectedAmount = this.state.selectedAmount;
		}

		switch (this.props.type) {
			case "button":
				return this.renderButton(selectedAmount);
			case "radio":
				return this.renderRadio(selectedAmount);
			case "dropdown":
				return this.renderDropdown(selectedAmount);
			default:
				console.error("Invalid type for GiftArray");
				return null;
		}
	}

	render() {
		var amounts = this.state.giftAmounts;
		var reactComponentName;

		if (!this.props.isDesignMode && (!amounts || amounts.length <= 0)) {
			return null;
		}

		switch (this.props.type) {
			case "button":
				reactComponentName = "ButtonGiftArray";
				break;
			case "radio":
				reactComponentName = "RadioGiftArray";
				break;
			case "dropdown":
				reactComponentName = "SelectGiftArray";
				break;
			default:
				console.error("Invalid type for GiftArray");
				return null;
		}
		reactComponentName = this.props.beginningComponentName + reactComponentName;

		return (
			<div
				className="gift-array"
				data-react-component-name={reactComponentName}
				data-react-component-category={this.props.reactComponentCategory}
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				{amounts && amounts.length > 0 ?
					this.renderContainer()
					:
					<div className="collapsedComponentPlaceholder">Gift Array</div>
				}
			</div>
		);
	}
}

GiftArray.defaultProps = {
	beginningComponentName: ""
};

GiftArray.propTypes = {
	isDesignMode: PropTypes.bool,
	giftAmounts: PropTypes.array,
	includeOther: PropTypes.bool,
	otherText: PropTypes.string,
	type: PropTypes.oneOf(["button", "radio", "dropdown"]).isRequired,
	showDecimals: PropTypes.bool,
	includeCurrencySymbol: PropTypes.bool,
	buttonStyle: PropTypes.object,
	minimumAmount: PropTypes.number,
	childClass: PropTypes.string,
	hideWhenSubaccounts: PropTypes.bool,
	context: PropTypes.string,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	tangibleActions: PropTypes.object,
	tangibleStore: PropTypes.object,
	thisArg: PropTypes.object,
	tangibleType: PropTypes.string,
	displayCodeProperty: PropTypes.string,
	reactComponentCategory: PropTypes.string
};

module.exports = GiftArray;
